type IconName =
  | 'arrow'
  | 'bank'
  | 'cash-in'
  | 'cash-out'
  | 'customer-normal'
  | 'customer-watch'
  | 'customer-late'
  | 'done'
  | 'remind'
  | 'hide'
  | 'vendor-bill'
  | 'soren'

const PATHS: Record<IconName, string> = {
  arrow: 'M4 10h12m-5-5 5 5-5 5',
  bank: 'M2 7.5 10 3l8 4.5M3 8.5h14M5 8.5v7m5-7v7m5-7v7M2.5 16.5h15',
  'cash-in': 'M3 16h14M10 3v10m-4-4 4 4 4-4',
  'cash-out': 'M3 16h14M10 13V3M6 7l4-4 4 4',
  'customer-normal': 'M10 3a7 7 0 1 1 0 14 7 7 0 0 1 0-14z M6.5 10l2.4 2.4 4.6-5',
  'customer-watch': 'M10 3a7 7 0 1 1 0 14 7 7 0 0 1 0-14z M10 6.5v4l2.5 1.5',
  'customer-late': 'M10 3a7 7 0 1 1 0 14 7 7 0 0 1 0-14z M10 6v5 M10 13.5h.01',
  done: 'M10 3a7 7 0 1 1 0 14 7 7 0 0 1 0-14z M6.5 10l2.5 2.5 4.5-5',
  remind: 'M10 3a7 7 0 1 1 0 14 7 7 0 0 1 0-14z M10 6.5v4l2.8 1.6',
  hide: 'M4 4l12 12 M7 7.4A6 6 0 0 0 4 10a8 8 0 0 0 12 0 6 6 0 0 0-1.6-2',
  'vendor-bill': 'M5 2.5h7l3 3v12H5zM12 2.5v3h3M7.5 10h5M7.5 13h5',
  soren: 'M10 2.5 11.8 8 17 10l-5.2 2L10 17.5 8.2 12 3 10l5.2-2z',
}

export default function CrIcon({ name, label }: { name: IconName; label?: string }) {
  return (
    <svg className="cr-icon" viewBox="0 0 20 20" aria-hidden={label ? undefined : true} aria-label={label}>
      <path d={PATHS[name]} fill="none" stroke="currentColor" strokeWidth="1.8" strokeLinecap="round" strokeLinejoin="round" />
    </svg>
  )
}
